import {
  FILTER_TYPE_TEXT,
  FILTER_TYPE_MULTISELECT,
  FILTER_TYPE_DATETIME,
  FILTER_TYPE_INTEGER
} from "@/store/system/helpers";
import store from "@/store";

export function getBlankCriteria() {
  return {
    type: [],
    informationSessionNumber: null,
    reference: null,
    action: [],
    fromDate: null,
    toDate: null,
    providerName: null,
    providerCode: null
  };
}

export function getSearchFilters() {
  return [
    {
      text: "Type",
      value: "type",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.noticeTypes
    },
    { text: "Provider name", value: "providerName", width: 8, type: FILTER_TYPE_TEXT },
    { text: "Provider code", value: "providerCode", width: 4, type: FILTER_TYPE_INTEGER },
    {
      text: "From date",
      value: "fromDate",
      width: 6,
      type: FILTER_TYPE_DATETIME
    },
    {
      text: "To date",
      value: "toDate",
      width: 6,
      type: FILTER_TYPE_DATETIME
    },
    { text: "Reference", value: "reference", width: 6, type: FILTER_TYPE_TEXT },
    {
      text: "Information session number",
      value: "informationSessionNumber",
      width: 6,
      type: FILTER_TYPE_INTEGER
    }
  ];
}

export function getBlankRecord() {
  return {
    id: null,
    date: null,
    levyCollectionId: null,
    levyCollectionYear: null,
    levyCollectionType: null,
    levyCollection: null,
    providerId: null,
    type: null,
    action: null,
    providerName: null,
    from: null,
    to: null,
    cc: null,
    subject: null,
    body: null
  };
}

export function getBlankResendDetails() {
  return {
    to: null,
    cc: null,
    noticeId: null
  };
}

export function getBlankNotices() {
  return {
    levyCollectionId: null,
    providerId: null
  };
}
